// Make Leaflet available globally for plugins that expect window.L
// (e.g., leaflet-rotate). Must be imported BEFORE any such plugins.
import L from 'leaflet';
window.L = L;
